import React from 'react';
import styles from './DataTableGrid.module.scss';
import { IoChevronForward, IoChevronBack } from 'react-icons/io5';
import { $t } from '../../../helpers/translator';
import Loader from '../../miscellaneous/Loader/Loader';
import _ from "lodash";

class DataTableGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    componentDidMount() {
        // console.log('in dtg...', this.props);
    }

    renderPagination() {
        if (!this.props.pagination || this.props.pagination.last_page === 1) {
            return null;
        }

        let numbers = [];
        let paginationNumbers = [];

        // adding all pagination numbers:
        for (let i = 1; i <= this.props.pagination.last_page; i++) {
            numbers.push(i);
        }

        //removing pagination numbers not to be displayed:
        if (this.props.pagination.last_page > 5) {
            for (let i = 0; i < numbers.length; i++) {
                let showAround = 1;
                if (this.props.pagination.current_page === 1 || this.props.pagination.current_page === this.props.pagination.last_page) {
                    showAround = 3
                }
                if (this.props.pagination.current_page === 2 || this.props.pagination.current_page === this.props.pagination.last_page - 1) {
                    showAround = 2
                }

                if (numbers[ i ] !== 1 &&
                    numbers[ i ] !== this.props.pagination.last_page &&
                    numbers[ i ] !== this.props.pagination.current_page &&
                    (
                        numbers[ i ] > this.props.pagination.current_page + showAround
                        ||
                        numbers[ i ] < this.props.pagination.current_page - showAround
                    )
                ) {
                    if (numbers[ i - 1 ] && numbers[ i - 1 ] !== '...') {
                        numbers[ i ] = '...';
                    }
                    else {
                        numbers.splice(i--, 1)
                    }
                }
            }
        }

        _.forEach(numbers, (v, k) => {
            paginationNumbers.push(<div key={ k } onClick={ () => this.changePage(v) }
                // styleName={'num ' + (v === this.props.pagination.current_page ? 'selected-pg ' : '')
                // + (this.getIsPageClickable(v) ? 'pointer-cursor' : '')}
                className={ `${styles[ 'num' ]} ${(v === this.props.pagination.current_page ? styles[ 'selected-pg' ] : '')} ${(this.getIsPageClickable(v) ? styles[ 'pointer-cursor' ] : '')}` }
            >{ v }</div>)
        })

        return (
            <div className={ `${styles[ 'pagination-container' ]}` }>
                <div
                    className={ `${styles[ 'num' ]} ${styles[ (this.getIsPageClickable(this.props.pagination.current_page - 1) ? 'pointer-cursor' : 'grayed-out') ]}` }
                    // styleName={'num ' + (this.getIsPageClickable(this.props.pagination.current_page - 1) ? 'pointer-cursor' : 'grayed-out')}
                    onClick={ () => this.changePage(this.props.pagination.current_page - 1) }>
                    <IoChevronBack /></div>
                { paginationNumbers }
                <div
                    className={ `${styles[ 'num' ]} ${styles[ (this.getIsPageClickable(this.props.pagination.current_page + 1) ? 'pointer-cursor' : 'grayed-out') ]}` }
                    // styleName={'num ' + (this.getIsPageClickable(this.props.pagination.current_page + 1) ? 'pointer-cursor' : 'grayed-out')}
                    onClick={ () => this.changePage(this.props.pagination.current_page + 1) }>
                    <IoChevronForward /></div>
            </div>
        );
    }

    getIsPageClickable(page) {
        if (isNaN(page)) {
            return false;
        }

        return !(page > this.props.pagination.last_page || page < 1 || page === this.props.pagination.current_page);
    }

    changePage(pg) {
        if (!this.getIsPageClickable(pg)) {
            return;
        }

        this.emitAction('page', pg);
        // this.setState({ expandedRows: new Array(this.props.pagination.per_page) });
    }

    emitAction(key, value) {
        this.props.onAction({
            key: key,
            value: value
        });

        // this.setState({expandedRows: new Array(this.props.data.length)})
    }

    render() {
        let fromC = this.props.pagination && this.props.pagination.from ? this.props.pagination.from : 0;
        let toC = this.props.pagination && this.props.pagination.to ? this.props.pagination.to : 0;
        let totalC = this.props.pagination && this.props.pagination.total ? this.props.pagination.total : 0;
        // let displayStr = $t('global.general.displayingOutOf', fromC, toC, totalC)
        let displayStr = $t('global.general.displayingOutOf', [ fromC, toC, totalC ]);

        return (
            <div className={ `${styles[ 'container' ]}` }>
                { this.props.loading ?
                    <div className={ `${styles[ 'loader-container' ]}` }>
                        <Loader />
                    </div>
                    :
                    null
                }
                <div className={ `${styles[ 'header-row' ]}` }>
                    {
                        this.props.pagination ?
                            <div>
                                { displayStr }
                            </div>
                            : null
                    }
                </div>

                <div className={ `${styles[ 'children-container' ]}` }>
                    { this.props.data.map((v, k) => (
                        <div className={ `${styles[ 'child' ]}` } key={ 'dtg-' + k }>
                            { v }
                        </div>
                    )) }

                    { !this.props.data || !this.props.data.length ?
                        <span>{ $t('global.general.noDataToDisplay') }</span>
                        :
                        null
                    }
                </div>
                { this.renderPagination() }
            </div>
        );
    }
}

export default DataTableGrid;
